<ng-container *ngrxLet="environmentStatus$; let status">
    <div
        class="system-warning flex flex-row items-center place-content-center {{ status?.className }}"
        [ngClass]="{ active: status?.className }"
    >
        {{ status?.message }}
    </div>
</ng-container>
